
const data = [
    {id:1 , link : '#' , title:'Home'},
    {id:2 , link : '#about' , title:'About'},
    {id:2 , link : '#experience' , title:'Experience'},

    {id:3 , link : '#portfolio' , title:'Portfolio'},
    {id:4 , link : '#contact' , title:'Contact'}

]

export default data;